import { useTranslation } from 'react-i18next'
import { ConfigurationHeaderWrapper } from '../../_components/configuration-header-wrapper.component'
import ContentSvg from '/assets/img/content.svg'
import ExternalLinkSvg from '/assets/img/external-link.svg'
import { LocalizedLink } from 'src/components/navigation/localized-link.component'
import { useParams } from 'react-router-dom'

export default function AddContentPage() {
  const { projectId } = useParams<{ projectId: string }>()
  const { t } = useTranslation()

  return (
    <ConfigurationHeaderWrapper title={t('pages.configuration.contents.add-content')}>
      <div className="c-flex c-w-full c-h-full c-items-center c-justify-center">
        <LocalizedLink
          to={`/${projectId}/configuration/contents/add/content`}
          className="c-text-primary c-font-bold c-flex c-flex-col c-items-center c-gap-2 c-mx-8 c-text-base hover:c-underline"
        >
          <img src={ContentSvg} alt="" />
          {t('pages.configuration.contents.create-new-content')}
        </LocalizedLink>
        <LocalizedLink
          to={`/${projectId}/configuration/contents/add/external-link`}
          className="c-text-primary c-font-bold c-flex c-flex-col c-items-center c-gap-2 c-mx-8 c-text-base hover:c-underline"
        >
          <img src={ExternalLinkSvg} alt="" />
          {t('pages.configuration.contents.add-external-link')}
        </LocalizedLink>
      </div>
    </ConfigurationHeaderWrapper>
  )
}
